import { useMemo } from 'react';

import { TAdBannerPlaceParameters } from '../../AdBannerMicrofrontendContainer';

/**
 * Константы места TGB-баннера между объявлениями.
 *
 * Значения должны совпадать с легаси-размещением Adfox (TGBBanner), чтобы показывалась
 * та же рекламная кампания: place — аналитическое место, pParams — p1/p2 размещения
 * (для новостроечной и обычной выдачи разные p1), sizes — размеры баннера.
 */
const PLACE = 'between_offers';
const P_PARAMS: TAdBannerPlaceParameters['pParams'] = { p1: 'ddcfw', p2: 'fkhj' };
const P_PARAMS_NEWBUILDING: TAdBannerPlaceParameters['pParams'] = { p1: 'davxz', p2: 'fkhj' };
const SIZES: TAdBannerPlaceParameters['sizes'] = { width: '100%', height: 376 };

interface IUseTgbParametersParams {
  position: number;
  isNewbuilding: boolean;
}

/**
 * Параметры места TGB-баннера между объявлениями (desktop-выдача).
 */
export function useTgbParameters({ position, isNewbuilding }: IUseTgbParametersParams): TAdBannerPlaceParameters {
  return useMemo(
    () => ({
      place: PLACE,
      pParams: isNewbuilding ? P_PARAMS_NEWBUILDING : P_PARAMS,
      sizes: SIZES,
      position,
      galleryPosition: null,
      isSp: false,
      tgbNativedescGeneralDesign: 'desktop-listing',
      carousel: null,
      deviceType: 'desktop',
    }),
    [isNewbuilding, position],
  );
}
